import { DefaultService } from '@/services/DefaultService';


export default class AssFormaPagamentoEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assformapagtoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assformapagtoempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllNaoAssociados(column, order, page, limit, idempresa, isAssociado = false, ...params) {
        return this._http.get( encodeURI(`${this._env}/empresa/assformapagtoempresa/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&isassociado=${isAssociado}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    find(id) {
		return this._http.get(`${this._env}/ven/empresa/assformapagtoempresa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assformapagtoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assformapagtoempresa/updatesituacao`, assformapagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assformapagtoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assformapagtoempresa/updatesituacao`, assformapagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(assformapagtoempresa) {
        return this._http.post(`${this._env}/ven/empresa/assformapagtoempresa`, assformapagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(assformapagtoempresa) {
        return this._http.post(`${this._env}/agro/empresa/assformapagtoempresa`, assformapagtoempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}